export class ContactsActions {
  static readonly SET_CONTACTS = '[CONTACTS] SET';
  static readonly UPDATE_CONTACT = '[CONTACTS] UPDATE';
  static readonly ADD_CONTACTS = '[CONTACTS] ADD_CONTACTS';
}
